<div class="modal__content assign-score">
  <button class="modal__close-btn" (click)="onClose()">
    <span [innerHTML]="ICONS.closeCircleIcon | safeHtml"></span>
  </button>
  <div class="assign-score__header">
    <h2 class="assign-score__title">Assign Score</h2>
    <a href="#" class="assign-score__link" (click)="showScoring(); onClose()">How points system work?</a>
  </div>

  <div class="assign-score__body">
    <label for="score" class="assign-score__label"
      >Score
      <span class="selfScore" *ngIf="value"
        >Score: <b>{{ value }}</b></span
      >
    </label>
    <div class="assign-score__slider" *ngIf="isInitialized">
      <input
        type="range"
        id="score"
        class="assign-score__range"
        [style.background]="'linear-gradient(to right, #433D3D 0%, #FF1300 ' + percent + '%, #e0e0e0 ' + percent + '%, #e0e0e0 100%)'"
        min="{{ minFicorScore }}"
        max="{{ maxValue }}"
        [value]="value"
        (input)="changeRange($event)"
        step="1"
      />
      <div class="assign-score__ticks">
        <span class="assign-score__tick">{{ minFicorScore }}</span>
        <span class="assign-score__tick">{{ breakPoints[1] != minFicorScore && breakPoints[1] != maxValue ? breakPoints[1] : '' }}</span>
        <span class="assign-score__tick">{{ breakPoints[2] != minFicorScore && breakPoints[2] != maxValue ? breakPoints[2] : '' }}</span>
        <span class="assign-score__tick">{{ breakPoints[3] != minFicorScore && breakPoints[3] != maxValue ? breakPoints[3] : '' }}</span>
        <span class="assign-score__tick">{{ breakPoints[4] != minFicorScore && breakPoints[4] != maxValue ? breakPoints[4] : '' }}</span>
        <span class="assign-score__tick">{{ maxValue }}</span>
      </div>
    </div>
    <p class="assign-score__note">The assigned score cannot be changed once you click submit.</p>

    <div class="assign-score__reject">
      <input
        type="checkbox"
        id="reject"
        class="popup__checkbox assign-score__checkbox"
        [(ngModel)]="isRejected"
        (change)="onCheckboxChange($event)"
      />
      <label for="reject" class="assign-score__checkbox-label"
        >If you believe this post doesn’t deserve the score and want to reject it, check this box</label
      >
    </div>
    @if (isRejected) {
      <div class="reaction__fields scrore">
        <label class="label__name">Add Reason for Rejecting*</label>
        <div class="popup__radio-group">
          <label class="popup__radio-option" [class.popup__radio-option--active]="reasonSelected === option" *ngFor="let option of options">
            <input
              type="radio"
              name="status"
              class="popup__radio popup__radio--checkbox"
              [value]="option"
              [checked]="reasonSelected === option"
              (change)="onSelectionChange($event)"
            />{{ option }}
          </label>
        </div>
      </div>
    }
  </div>

  <div class="assign-score__footer">
    <button class="assign-score__submit-btn" (click)="confirm()">Submit</button>
  </div>
</div>
